import modularScale from 'modularscale-js';
import compose from 'compose-function';

const pxPad = v => (v.toString().indexOf('px') !== -1 ? v : `${v}px`);

const pxPadAll = partialed =>
  Object.entries(partialed).reduce((acc, [k, v]) => {
    acc[k] = pxPad(v);
    return acc;
  }, {});

export default function createScale({ base = 16, ratio = 1.618 }) {
  return function makeSpaces(spaces) {
    const SPACE = Array(spaces)
      .fill()
      .map((_x, i) =>
        Math.round(
          modularScale(i - 2, {
            base,
            ratio,
          }),
        ),
      );

    return SPACE;
  };
}

export const fourScale = compose(
  pxPadAll,
  sizes =>
    sizes.reduce((acc, [k, v]) => {
      acc[k] = v;
      return acc;
    }, {}),
  spaces =>
    Array(spaces)
      .fill()
      .map((_x, i) => [i, i * 4]),
);

export const xScale = x =>
  compose(
    /*
     * sizes =>
     *   sizes.reduce((acc, [k, v]) => {
     *     acc[k] = v;
     *     return acc;
     *   }, {}),
     */
    spaces =>
      Array(spaces)
        .fill()
        .map((_x, i) => pxPad(i * x)),
  );

export const tenScale = compose(
  pxPadAll,
  scale => ({
    '.25': 2.5,
    '0.25': 2.5,
    '.5': 5,
    '0.5': 5,
    ...scale,
  }),
  sizes =>
    sizes.reduce((acc, [k, v]) => {
      acc[k] = v;
      return acc;
    }, {}),
  spaces =>
    Array(spaces)
      .fill()
      .map((_x, i) => [i, i * 10]),
);

export const splitAtRoot = rootValue => scale => {
  const rawScale = scale.map(x => Number(x.replace('px', '')));
  if (!Array.isArray(rawScale)) {
    const splitty = Object.entries(
      rawScale.reduce((acc, curr) => {
        if (!acc.neg) {
          acc.neg = [];
        }
        if (!acc.pos) {
          acc.pos = [];
        }
        if (curr < rootValue) {
          acc.neg.push(curr);
        }
        if (curr >= rootValue) {
          acc.pos.push(curr);
        }
        return acc;
      }, {}),
    ).reduce((acc, v) => {
      if (v[0] === 'pos') {
        v[1].forEach((c, idx) => {
          if (c >= rootValue) {
            acc[idx + 1] = pxPad(c);
          }
        });
      }
      if (v[0] === 'neg') {
        v[1]
          .sort()
          .reverse()
          // eslint-disable-next-line array-callback-return
          .reduce((_neg, val, idx) => {
            acc[`n${idx + 1}`] = pxPad(val);
          }, {});
      }
      acc[0] = 0;
      return acc;
    }, {});
    return splitty;
  }
  const splitty = Object.entries(
    rawScale.reduce((acc, curr) => {
      if (curr === 0) {
        return acc;
      }
      if (!acc.neg) {
        acc.neg = [];
      }
      if (!acc.pos) {
        acc.pos = [];
      }
      if (curr < rootValue) {
        acc.neg.push(curr);
      }
      if (curr >= rootValue) {
        acc.pos.push(curr);
      }
      return acc;
    }, {}),
  ).reduce((acc, v) => {
    if (v[0] === 'pos') {
      v[1].forEach((c, idx) => {
        if (c >= rootValue) {
          acc[idx + 1] = pxPad(c);
        }
      });
    }
    if (v[0] === 'neg') {
      v[1]
        .sort()
        // eslint-disable-next-line array-callback-return
        .reduce((_neg, val, idx) => {
          acc[`n${idx + 1}`] = pxPad(val);
        }, {});
    }
    acc[0] = 0;
    return acc;
  }, {});

  return splitty;
};

export const addNegatives = scale =>
  scale.reduce((acc, curr, i) => {
    acc[i] = curr;
    acc[`n${i}`] = `-${curr}`;
    return acc;
  }, {});
